import Head from 'next/head'

interface JsonLdScriptProps {
  id: string
  content: Record<string, any>
}

// O JSON vai cru para dentro de um <script>: um `</script>` vindo do conteúdo (pergunta
// do FAQ, avaliação de produto) fecharia a tag e o resto viraria HTML. Os escapes \uXXXX
// mantêm o JSON válido, e o JSON.parse devolve o mesmo objeto. TNDC-437.
export const serializeJsonLd = (content: Record<string, any>) =>
  JSON.stringify(content)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')

export default function JsonLdScript({ id, content }: JsonLdScriptProps) {
  return (
    <Head>
      <script
        id={id}
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: serializeJsonLd(content) }}
      />
    </Head>
  )
}
